// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import cn from 'classnames';
import hopt from 'hola_opt';
import {url2md5} from 'pub_config';
import zutil from 'zutil';
import {use_qs} from '../lib/use_qs';
import experiment_init from '../experiment_init';
import styles from './plan_banner.module.less';

const banners = {
    special_offer_47: {
        img: 'plan_banner_special_47.svg',
    },
};

interface i_plan_banner_props {
    plan_id: string;
}
export const Plan_banner = (props:i_plan_banner_props)=>{
    const {plan_id} = props;
    const conf = zutil.get(hopt, `www_hola.plan_banners.${plan_id}`, {});
    const qs = use_qs();
    const hide = !conf.enabled && !qs.debug_ui ||
        conf.hide?.tests?.some(t=>experiment_init.ui_test[t] ||
            qs[`debug_${t}`]);
    if (hide)
        return null;
    const b = banners[conf.banner];
    return !b ? null : <div className={cn(styles.plan_banner, b.cls)}>
      <img src={url2md5(`/www/hola/pub/img/plus/${b.img}`)} alt="banner_img"
        className="lazyload"/>
    </div>;
};
